import { runPlayerCommand } from '../PlayerAccounts/playerCreationOperation'

export const adminInvitationLabels = {
  pending: 'The invitation is queued. Sending has not yet been confirmed.',
  sending: 'The email service is sending the invitation.',
  sent: 'The email server accepted the invitation. This does not confirm delivery to the inbox.',
  failed: 'The invitation could not be sent.',
  unconfirmed: 'Invitation sending is not confirmed. Check its status before requesting another invitation.',
  superseded: 'A later invitation has replaced this request. Check the current invitation status.',
  consumed: 'The administrator has set a password and activated the account.',
  invalidated: 'The account details changed. Send a new invitation to activate this administrator.',
}
export const adminCreationMessage = code => ({
  ACCOUNT_ALREADY_EXIST: 'An account already uses this email address. Use a different email or open the existing account.',
  SUPER_ADMIN_REQUIRED: 'Only an activated SuperAdmin can manage administrative accounts.',
  INVITATION_ACCOUNT_CHANGED: 'The account changed while requesting the invitation. Check its current details and try again.',
  INVITATION_RATE_LIMITED: 'Please wait five minutes between invitation requests.',
  INVITATION_NOT_AVAILABLE: 'This account is no longer eligible for an invitation.',
  INVALID_ADMIN_LANGUAGE: 'This email language is no longer available. Reload the options and choose an available language.',
  INVALID_ADMIN_FIELDS: 'Review the account details before trying again.',
  ADMIN_INVITATION_REQUIRED: 'This administrator must set a password using an invitation before activation.',
  OPERATION_PAYLOAD_CONFLICT: 'This operation already has different details. Check its saved result before continuing.',
}[code] || 'The result is not confirmed. Check its status before trying again.')

export const runAdminCreationCommand = options => runPlayerCommand({ operation: 'admin-created', ...options, messageForCode: adminCreationMessage })
